import React, { Component } from 'react'
import { connect } from 'react-redux'
import trans from 'counterpart'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import Scrollchor from 'react-scrollchor'
import ComparableResources from './ComparableResources'
import { fetchAccommodationTypes, fetchPropertyGroups } from '../../booking/actions'
import { getOffersSelector } from '../../booking/selectors'
import { getPreferences } from '../../preferences/selectors'
import { returnResourcesAfterRemoval, setCompareProperty, resetCompareList, mapResourcesToState } from '../actions'
import { createCompareUrl } from '../utils'
import { MAX_COMPARE } from '../constants'
import { getAccommodationsById } from '../selectors'
import { getAccommodationTypes } from '../../../selectors/entitySelectors'
import AccommodationType from './AccommodationType'
import { fetchOffers } from '../../../actions/preferenceActions'
import { APP_DIERENBOS } from '../../../constants/apps'

const isIE11 = typeof navigator !== 'undefined' ? (navigator.appVersion.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1) : false

/**
 * TO DO:
 * There is still an issue with calls using the date of today and not the closest day with offers.
 * Does work if there is a hardcoded date for now.
 */
class CompareResourceBlock extends Component {
  state = {
    initialized: false,
    results: []
  }

  componentDidMount = () => {
    this.props.initialize()
      .then(() => this.props.getResourceIdsFromUrl(this.props.location.search))
      .then(() => this.props.fetchOffers())
      .then((data) => {
        if (!data) return null
        return this.setState({
          initialized: true,
          results: data.results.reduce((a, c) => ({ ...a, [c.resource_id]: c }), {})
        })
      })
  }

  componentWillUpdate = (newProps) => {
    const { setHasMaxCompare } = this.props
    if (newProps.hasMaxCompare) {
      setTimeout(() => setHasMaxCompare(false), 3000)
    }
  }

  componentWillUnmount = () => this.props.resetCompareList();

  removeFromCompareResources = (id) => {
    const { removeFromCompareList, history } = this.props
    const newResources = removeFromCompareList(id)
    history.push(`${history.location.pathname}?${createCompareUrl({ resources: newResources })}`)
  }

  render = () => {
    const { block, selectedAccommodations, compareListIds, hasMaxCompare } = this.props
    const { initialized, results } = this.state

    if (!initialized) return <div>Loading...</div>

    return (
      <div>
        <div id='compared-resources' className={`row compare-resources ${isIE11 ? 'isIE' : ''}`}>
          <div className='col px-0 loading-block loading-ts transparent'>
            <div className='results grid grid-compare container mt-4'>
              <div className='row'>
                {Object.values(selectedAccommodations).map(accommodationType => (
                  <AccommodationType
                    key={accommodationType.id}
                    accommodationType={accommodationType}
                    result={results[accommodationType.id]}
                    remove={this.removeFromCompareResources}
                    properties={block.properties.properties}
                  />
                ))}
                {compareListIds.length < MAX_COMPARE && (
                  <article className='result card card-white card-add thumbnail-add'>
                    <div className='result-left'>
                      <h4 className={`${process.env.RAZZLE_APP === APP_DIERENBOS && 'text-black'} mb-3`}>{trans('label.compare_more')}</h4>
                      <div className='card-block bg-beige-light'>
                        <Scrollchor to='comparable-resources'>
                          <span className='btn-add'>
                            {trans('label.add_accommodation')}
                            <br />
                            <span className='material-icons'>add_box</span>
                          </span>
                        </Scrollchor>
                      </div>
                    </div>
                  </article>
                )}
              </div>
            </div>
          </div>
        </div>
        <ComparableResources onChange={this.addToCompareList} compareList={this.state.compareList} />
        {hasMaxCompare && (
          <div className='alert alert-warning alert-compare'>
            <div className='container'>
              {`${trans('newyse.compare.max')}.`}
            </div>
          </div>
        )}
      </div>
    )
  }
}

CompareResourceBlock.propTypes = {
  block: PropTypes.object,
  compareListIds: PropTypes.array,
  fetchOffers: PropTypes.func,
  getResourceIdsFromUrl: PropTypes.func,
  hasMaxCompare: PropTypes.bool,
  history: PropTypes.object,
  location: PropTypes.object,
  initialize: PropTypes.func,
  removeFromCompareList: PropTypes.func,
  resetCompareList: PropTypes.func,
  selectedAccommodations: PropTypes.object,
  setHasMaxCompare: PropTypes.func
}

const mapStateToProps = state => ({
  accommodationTypes: getAccommodationTypes(state),
  compareListIds: state.compare.compareListIds,
  hasMaxCompare: state.compare.hasMaxCompare,
  hasIdInList: state.compare.hasIdInList,
  offers: getOffersSelector(state),
  preferences: getPreferences(state),
  selectedAccommodations: getAccommodationsById(state)
})

const mapDispatchToProps = dispatch => ({
  fetchOffers: () => dispatch(fetchOffers()),
  initialize: () => Promise.all([
    dispatch(fetchAccommodationTypes()),
    dispatch(fetchPropertyGroups())
  ]),
  removeFromCompareList: id => dispatch(returnResourcesAfterRemoval(id)),
  resetCompareList: () => dispatch(resetCompareList()),
  setHasMaxCompare: bool => dispatch(setCompareProperty('hasMaxCompare', bool)),
  getResourceIdsFromUrl: searchString => dispatch(mapResourcesToState(searchString))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CompareResourceBlock))
